import { render, staticRenderFns } from "./profiles-section.vue?vue&type=template&id=496f2258&scoped=true&"
import script from "./profiles-section.vue?vue&type=script&lang=js&"
export * from "./profiles-section.vue?vue&type=script&lang=js&"
import style0 from "./profiles-section.vue?vue&type=style&index=0&id=496f2258&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496f2258",
  null
  
)

export default component.exports